import { atom } from 'jotai'
import type { ChatUsage } from '../engine/events'

export type { ChatUsage }

/**
 * Per-chat usage totals from this window's live stream `usage` events, keyed
 * by the real conversation id the event carries. `useChatUsage` weighs them
 * against a fetched snapshot by `updatedAt`, since another window or device
 * may have run later turns.
 */
export const liveChatUsageAtom = atom<Record<string, ChatUsage>>({})
